module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "setting"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.userInfo.loading),
      expression: "userInfo.loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix card-heard"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.userInfo.isEdit ? "完成" : "编辑") + "\n                ")])], 1), _vm._v(" "), (_vm.userInfo.isEdit) ? _c('div', {
    staticClass: "user-info"
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px",
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.name),
      callback: function($$v) {
        _vm.userInfo.name = $$v
      },
      expression: "userInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.email),
      callback: function($$v) {
        _vm.userInfo.email = $$v
      },
      expression: "userInfo.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.phone),
      callback: function($$v) {
        _vm.userInfo.phone = $$v
      },
      expression: "userInfo.phone"
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 姓名")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 邮箱")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.email))])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 联系电话")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.phone))])])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix card-heard"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    编辑\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 旧密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 验证密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-130bda88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/setting.vue
// module id = 894
// module chunks = 1